import type Light from "./light/light";

interface FlagBase {
    label: string;
    icon?: string;
    color?: string;
    group?: string;
    index?: number;
    ignored?: boolean;
}

export interface NumericFlag extends FlagBase {
    value: number;
}

export interface FunctionFlag extends FlagBase {
    value: (lights: Light[]) => boolean;
}

export type Flag = NumericFlag | FunctionFlag;

/**
 * Type guard that narrows a Flag to NumericFlag.
 *
 * @param flag - The flag to check.
 * @returns Whether the flag has a numeric value.
 */
export const isNumericFlag = (flag: Flag): flag is NumericFlag =>
    typeof flag.value === "number";
